/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './termandcondition.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../../app/shared/ui/termandcondition/termandcondition.component';
import * as import3 from '../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import4 from '@angular/material';
import * as import5 from '@angular/forms';
import * as import6 from '@angular/common';
const styles_TermandconditionComponent:any[] = [import0.styles];
export const RenderType_TermandconditionComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_TermandconditionComponent,
  data: {}
}
);
export function View_TermandconditionComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'div',[[
        'align',
        'left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'md-checkbox',[
      [
        'class',
        'mat-checkbox'
      ]
      ,
      [
        'name',
        'tnc'
      ]
      ,
      [
        'style',
        'margin-top: 5%'
      ]
      ,
      [
        'type',
        'checkbox'
      ]

    ]
    ,[
      [
        2,
        'mat-checkbox-indeterminate',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-checked',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-disabled',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-label-before',
        (null as any)
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.TermandconditionComponent = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.termsAndConditionAccepted = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('change' === en)) {
        const pd_1:any = ((<any>co.onChange()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import3.View_MdCheckbox_0,import3.RenderType_MdCheckbox)),
    import1.ɵdid(4374528,(null as any),0,import4.MdCheckbox,[
      import1.Renderer2,
      import1.ElementRef,
      import1.ChangeDetectorRef,
      import4.FocusOriginMonitor
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      name: [
        1,
        'name'
      ]

    }
    ,{change: 'change'}),
    import1.ɵprd(1024,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import4.MdCheckbox]),
      import1.ɵdid(671744,[[
        'tnc',
        4
      ]
    ],0,import5.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import5.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      isDisabled: [
        1,
        'isDisabled'
      ]
      ,
      model: [
        2,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import5.NgControl,(null as any),[import5.NgModel]),
    import1.ɵdid(16384,(null as any),0,import5.NgControlStatus,[import5.NgControl],(null as any),(null as any)),
    import1.ɵdid(16384,(null as any),0,import4.MdPrefixRejector,[
      [
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n    I agree to the\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'download',
        ''
      ]
      ,
      [
        'name',
        'lnkTC'
      ]

    ]
      ,[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' Terms & Conditions'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import2.TermandconditionComponent = v.component;
    const currVal_11:any = co.isReadOnly;
    const currVal_12:any = 'tnc';
    ck(v,3,0,currVal_11,currVal_12);
    const currVal_13:any = 'tnc';
    const currVal_14:any = co.isReadOnly;
    const currVal_15:any = co.termsAndConditionAccepted;
    ck(v,5,0,currVal_13,currVal_14,currVal_15);
  },(ck,v) => {
    var co:import2.TermandconditionComponent = v.component;
    const currVal_0:any = import1.ɵnov(v,3).indeterminate;
    const currVal_1:any = import1.ɵnov(v,3).checked;
    const currVal_2:any = import1.ɵnov(v,3).disabled;
    const currVal_3:any = (import1.ɵnov(v,3).labelPosition == 'before');
    const currVal_4:any = import1.ɵnov(v,7).ngClassUntouched;
    const currVal_5:any = import1.ɵnov(v,7).ngClassTouched;
    const currVal_6:any = import1.ɵnov(v,7).ngClassPristine;
    const currVal_7:any = import1.ɵnov(v,7).ngClassDirty;
    const currVal_8:any = import1.ɵnov(v,7).ngClassValid;
    const currVal_9:any = import1.ɵnov(v,7).ngClassInvalid;
    const currVal_10:any = import1.ɵnov(v,7).ngClassPending;
    ck(v,2,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10
    ]
    );
    const currVal_16:any = co.tNc;
    ck(v,10,0,currVal_16);
  });
}
function View_TermandconditionComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-termandcondition',([] as any[]),(null as any),(null as any),(null as any),View_TermandconditionComponent_0,RenderType_TermandconditionComponent)),
    import1.ɵdid(49152,(null as any),0,import2.TermandconditionComponent,[import6.PlatformLocation],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const TermandconditionComponentNgFactory:import1.ComponentFactory<import2.TermandconditionComponent> = import1.ɵccf('app-termandcondition',import2.TermandconditionComponent,View_TermandconditionComponent_Host_0,{
  termsAndConditionAccepted: 'termsAndConditionAccepted',
  isReadOnly: 'isReadOnly'
}
,{termAndConditionStatusChange: 'termAndConditionStatusChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/ui/termandcondition/termandcondition.component.ngfactory.ts